import { Api } from '../../Api';
import { ListResult } from '../../interfaces';
import { SettingsUsersUserDto, SettingsUsersUserFullDto } from './interfaces';
import { SettingsUsersPostBody, SettingsUsersPutBody } from './body';
import { SettingsUsersGetByIdParams, SettingsUsersPutByIdParams, SettingsUsersDeleteByIdParams } from './params';
import { SettingsUsersGetQuery } from './query';
import { getSettingsUsersMockUsers, getSettingsUsersMockUser } from './mocks';
import { ISettingsPositionsGetQuery } from '../Positions';

export class Users {
    private static _basePath = '/users';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Users._basePath}`;
        return {
            async get(query: SettingsUsersGetQuery, isMock: boolean = false) {
                const path = '/';
                return await Api.get<ListResult<SettingsUsersUserDto>>({
                    path: `${basePath}${path}`,
                    query,
                    isMock,
                    mock: () => getSettingsUsersMockUsers({ page: query.page, pageSize: query.recordsCount }),
                    mockName: 'Get Users',
                });
            },
            async post(body: SettingsUsersPostBody, isMock: boolean = false) {
                const path = '/';
                return await Api.post<void>({
                    path: `${basePath}${path}`,
                    body,
                    isMock,
                    mock: () => undefined,
                    mockName: 'Post User',
                });
            },
            async getById({ id }: SettingsUsersGetByIdParams, isMock: boolean = false) {
                const path = '/';
                return await Api.get<SettingsUsersUserFullDto>({
                    path: `${basePath}${path}${id}`,
                    isMock,
                    mock: getSettingsUsersMockUser,
                    mockName: 'Get User By Id',
                });
            },
            async putById({ id }: SettingsUsersPutByIdParams, body: SettingsUsersPutBody, isMock: boolean = false) {
                const path = '/';
                return await Api.put<void>({
                    path: `${basePath}${path}${id}`,
                    body,
                    isMock,
                    mock: () => undefined,
                    mockName: 'Put User By Id',
                });
            },
            async deleteById({ id }: SettingsUsersDeleteByIdParams, isMock: boolean = false) {
                const path = '/';
                return await Api.delete<void>({
                    path: `${basePath}${path}${id}`,
                    isMock,
                    mock: () => undefined,
                    mockName: 'Delete User By Id',
                });
            },

            async getclientDashboard(AccountId: number) {
                const path = `/clientDashboard?AccountId=${AccountId}`;
                return await Api.get<any>({
                    path: `${parentPath}/User${path}`,
                });
            },

            async authenticateUser() {
                try {
                    const response = await Api.post<any>({
                        path: `${parentPath}/User/authenticate`, // Calls the .NET Authenticate endpoint
                        body: {
                            wmId: 501,
                            username: 'bilalsaeedtrail2',
                            password: 'Password123!',
                        },
                    });

                    if (!response || !response.sid) {
                        throw new Error('Authentication failed: No session ID received.');
                    }

                    return response.sid;
                } catch (error) {
                    return null;
                }
            },

            async fetchStockQuotes(symbols: string, sessionId: string) {
                const path = `/User/quotes?webmasterId=501&symbols=${symbols}&sid=${sessionId}`;

                try {
                    const response = await Api.get<any>({
                        path: `${parentPath}${path}`, // Calls the .NET Quotes API
                    });

                    return response;
                } catch (error) {
                    return null;
                }
            },

            async fetchFullHistory(symbol: string, sessionId: string, start: string, end: string) {
                const path = `/User/fullhistory?webmasterId=501&symbol=${symbol}&start=${start}&end=${end}&sid=${sessionId}`;

                try {
                    const response = await Api.get<any>({
                        path: `${parentPath}${path}`, // Calls the .NET Quotes API
                    });

                    return response;
                } catch (error) {
                    return null;
                }
            },

            async getRIADashboard(AccountId: number) {
                const path = `/riaDashboard?AccountId=${AccountId}`;
                return await Api.get<any>({
                    path: `${parentPath}/User${path}`,
                });
            },
            async getOperationsDashboard() {
                const path = `/operationsDashboard`;
                return await Api.get<any>({
                    path: `${parentPath}/User${path}`,
                });
            },
            async getRIAListing(query: ISettingsPositionsGetQuery) {
                const path = `/riaListing`;
                return await Api.get<ListResult<any>>({
                    path: `${parentPath}/User${path}`, // need to verify it
                    query,
                });
            },
        };
    }
}
